'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _latlng = require('./latlng');

var _latlng2 = _interopRequireDefault(_latlng);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _propTypes2.default.arrayOf(_latlng2.default);


//////////////////
// WEBPACK FOOTER
// ./~/react-leaflet/lib/propTypes/latlngList.js
// module id = 166
// module chunks = 0